import { render, staticRenderFns } from "./CouponType.vue?vue&type=template&id=5260fe91&scoped=true&"
import script from "./CouponType.vue?vue&type=script&lang=js&"
export * from "./CouponType.vue?vue&type=script&lang=js&"
import style0 from "./CouponType.vue?vue&type=style&index=0&id=5260fe91&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5260fe91",
  null
  
)

export default component.exports